import './index.css';

import { SortingToggleOptions } from '../../types';
import { useRef } from 'react';

import { SubscriptionSummary } from '../../../../types/subscription';
import Wrapper from './Wrapper';
import ExpandableModal from '../../../../components/ExpandableModal';
import { OverviewChartsContext } from './context';
import useWidthBreakpoint from '../../../../hooks/useWidthBreakpoint';

interface Props {
  totalValue: number;
  subscriptions: Array<SubscriptionSummary>;
}

const ClusterOverviewCharts: React.FC<Props> = (props: Props) => {
  const { totalValue, subscriptions } = props;

  const { isMatch } = useWidthBreakpoint();
  const rootRef = useRef<any>(null);

  return (
    <div
      style={{
        marginLeft: !isMatch('md') ? 32 : 32,
        marginRight: !isMatch('md') ? 64 : 32,
        position: 'relative',
        scrollSnapAlign: 'center',
        display: 'flex',
        height: '100%',
        flexDirection: 'column',
        marginBottom: !isMatch('md') ? 32 : 0,
      }}
      ref={rootRef}
    >
      <OverviewChartsContext
        totalValue={totalValue}
        subscriptions={subscriptions}
      >
        <div
          style={{
            display: 'flex',
            justifyContent: !isMatch('md') ? 'start' : 'space-between',
            flexDirection: !isMatch('md') ? 'column' : 'row',
            width: '100%',
            gap: !isMatch('md') ? 32 : 32,
            height: !isMatch('md') ? 'auto' : '35vh',
            marginBottom: !isMatch('md') ? 32 : '2%',
          }}
        >
          <ExpandableModal
            key={SortingToggleOptions.Diversity}
            parentRef={rootRef}
            supportScrolling={false}
          >
            <Wrapper activeToggleOption={SortingToggleOptions.Diversity} />
          </ExpandableModal>
          <ExpandableModal
            key={SortingToggleOptions.TotalStableProfit}
            parentRef={rootRef}
            supportScrolling={false}
          >
            <Wrapper
              activeToggleOption={SortingToggleOptions.TotalStableProfit}
            />
          </ExpandableModal>
          <ExpandableModal
            key={SortingToggleOptions.TotalAssetProfit}
            parentRef={rootRef}
            supportScrolling={false}
          >
            <Wrapper
              activeToggleOption={SortingToggleOptions.TotalAssetProfit}
            />
          </ExpandableModal>
        </div>
        <div
          style={{
            display: 'flex',
            justifyContent: !isMatch('md') ? 'start' : 'space-between',
            flexDirection: !isMatch('md') ? 'column' : 'row',
            width: '100%',
            gap: !isMatch('md') ? 32 : 32,
            height: !isMatch('md') ? 'auto' : '35vh',
            marginBottom: !isMatch('md') ? 0 : '2%',
          }}
        >
          <ExpandableModal
            key={SortingToggleOptions.NoAlgorithmicDifference}
            parentRef={rootRef}
            supportScrolling={false}
          >
            <Wrapper
              activeToggleOption={SortingToggleOptions.NoAlgorithmicDifference}
            />
          </ExpandableModal>
          <ExpandableModal
            key={SortingToggleOptions.CurrentStableProfit}
            parentRef={rootRef}
            supportScrolling={false}
          >
            <Wrapper
              activeToggleOption={SortingToggleOptions.CurrentStableProfit}
            />
          </ExpandableModal>
          <ExpandableModal
            key={SortingToggleOptions.CurrentAssetProfit}
            parentRef={rootRef}
            supportScrolling={false}
          >
            <Wrapper
              activeToggleOption={SortingToggleOptions.CurrentAssetProfit}
            />
          </ExpandableModal>
        </div>
      </OverviewChartsContext>
    </div>
  );
};

export default ClusterOverviewCharts;
